import React from 'react';
import PropTypes from 'prop-types';
import Replace from '../Replace';
import Link from '../../Link/Link';

import { getString } from '../../../helpers/stringHelpers';

/**
 * Replaces '$TermsOfUse' within a string with a link to the Privacy & Terms of Use page.
 */
function ReplaceTermsOfUse(props) {
	const { content, linkUrl } = props;

	const link = (
		<Link
			label={getString('replace', 'PRIVACY_TERMS_LINK_LABEL')}
			link={linkUrl}
			newTab={true}
		/>
	);

	return (
		<Replace content={content} toReplace='$TermsOfUse' replaceWith={link} />
	);
}

ReplaceTermsOfUse.propTypes = {
	content: PropTypes.string.isRequired,
	linkUrl: PropTypes.string.isRequired,
};

ReplaceTermsOfUse.defaultProps = {};

export default ReplaceTermsOfUse;
